import { defineMessages } from "react-intl";

const PREFIX = "EmailConfirmedPage";
export default defineMessages({
  headerNoValidLink: {
    id: `${PREFIX}.header.noValidLink`,
    defaultMessage: "Sorry this link is no longer valid. It is easy to get a new one, we can e-mail you a new link",
  },
  headerSentNewLink: {
    id: `${PREFIX}.header.sentNewLink`,
    defaultMessage: "We just sent you a new link to your e-mail",
  },
  btnNewLink: {
    id: `${PREFIX}.btn.newLink`,
    defaultMessage: "Request a new link",
  },
});
